import type { ListingLocationProps } from '@/services/types/listings/mockListings'
import type { StoreLocation } from '@/services/types/mockStoreLocations'
import { formatShortAddressWithLocationName } from '@/utils/functions/addresses/formatShortAddressWithLocationName'
import { Typography } from '../Typography'

export interface FormattedTitleWithAddressProps {
  location: StoreLocation | ListingLocationProps
}
export const FORMATTED_TITLE_WITH_ADDRESS_TEST_ID = 'formatted-title-with-address-text-test-id'

export function FormattedTitleWithAddress({ location }: FormattedTitleWithAddressProps) {
  const { locationName, shortAddress } = formatShortAddressWithLocationName(location)
  return (
    <Typography.Paragraph data-testid={FORMATTED_TITLE_WITH_ADDRESS_TEST_ID} noMargin>
      <Typography.Text>{locationName}</Typography.Text>
      <br />
      <Typography.Text>{shortAddress}</Typography.Text>
    </Typography.Paragraph>
  )
}
